(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-recently-viewed"]) return;
  try {
    
function lkhAlignRecentCards(root) {
  root.querySelectorAll('[data-recently-viewed-container]').forEach(container => {
    if (container.dataset.lkhCardAlignment) return;
    container.dataset.lkhCardAlignment = 'true';
    let frame;
    let width = container.clientWidth;
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!container.isConnected) return;
        const cards = [...container.querySelectorAll('.product-recently-viewed-card')];
        cards.forEach(card => card.style.height = 'auto');
        const height = Math.ceil(Math.max(0, ...cards.map(card => card.getBoundingClientRect().height)));
        cards.forEach(card => card.style.height = height + 'px');
        container.dispatchEvent(new CustomEvent('rimg:load'));
      });
    };
    const observer = new MutationObserver(align);
    observer.observe(container, {childList:true, subtree:true, characterData:true});
    const resize = new ResizeObserver(() => {
      if (container.clientWidth !== width) {
        width = container.clientWidth;
        align();
      }
    });
    resize.observe(container);
    container.addEventListener('load', align, true);
    const unload = event => {
      if (!event.target.contains(container)) return;
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      container.removeEventListener('load', align, true);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    align();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => lkhAlignRecentCards(document), {once:true});
} else {
  lkhAlignRecentCards(document);
}
document.addEventListener('shopify:section:load', event => lkhAlignRecentCards(event.target));

  } catch(e) { console.error(e); }
})();
})();
